import { RelationalActionParameter } from "./RelationalActionParameter";
import { IFontSizeAutoAdjustable, instanceOfIFontSizeAutoAdjustable } from "./IFontSizeAutoAdjustable";

export interface IDynamicTemplateExecutable extends IFontSizeAutoAdjustable {
  dynamicTemplateFormats: RelationalActionParameter[];
  dynamicTemplateRegisteredId: string;  // undefinedもありうる？
  setValueFromExternalScript(value: string): void;
  adjustFontSize(): void;
  adjustObjectHeight(): void;
}

export function instanceOfIDynamicTemplateExecutable(instance: any): instance is IDynamicTemplateExecutable {
  if (!instance) { return false; }
  return (instance.dynamicTemplateFormats !== undefined)
    && (instance.setValueFromExternalScript !== undefined)
    && (instance.adjustFontSize !== undefined)
    && (!instance.adjustObjectHeight !== undefined)
    && (instanceOfIFontSizeAutoAdjustable(instance));
}
